import { RouteGuard } from "@/components/runtime/route-guard/RouteGuard";
import { useLocation } from "react-router-dom";

export default function UserAccessDenied() {
  const location = useLocation();
  const routeId = location.state?.from || location.pathname;

  return (
    <RouteGuard mode="feature" policy={routeId}>
      {null}
    </RouteGuard>
  );
}